import type {
  ISettingsParam,
  IStyleParam,
  SettingsParamType,
  StyleParamType,
} from '@wix/tpa-settings';
import { useSettings, useStyles } from '@wix/tpa-settings/react';

export const useCascadingSettings = () => {
  const settings = useSettings();
  const styles = useStyles();

  return {
    get: <T extends SettingsParamType, U extends StyleParamType>(
      settingsParam: ISettingsParam<T>,
      styleParam: IStyleParam<U>,
    ) => {
      const valueInSettings = settings.get(settingsParam);
      const valueInStyles = styles.get(styleParam);

      return valueInStyles ?? valueInSettings;
    },
  };
};
